module.exports = __webpack_public_path__ + "img/协会官媒@2x.a1bddd5f.png";